import React, { useState, useEffect } from "react";
import { Form, Input, Button, Typography, message, Row, Col, Spin } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import LeftLayout from "../pageHeader/LeftLayout";
import { useHistory, useLocation } from "react-router-dom";
import { routes } from "../../routes/Routes";
import { ERROR_INVALID_OTP, ERROR_SENDING_OTP, OTP_SENT, OTP_VERIFIED_SUCCESSFULLY, COMMON_ERROR_MSG, SESSION_TOKEN } from "../../constants/constants";
import _NewapplicationService from "../../modules/NewapplicationService";
import IntegerInput from "../../components/IntergerInput";

const { Title, Text } = Typography;

const RegisteredEmailOtp = () => {
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(120);
  const history = useHistory();

  const location = useLocation();
  let data = location.state;
  let emailId = "";
  if (data && data.email) {
    emailId = data.email;
  }

  const [email] = useState(emailId);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => setTimer((t) => t - 1), 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  
  const onBack = () => {
    history.push(routes.registeredEmail.path);
  }

  const onFinish = async (values) => {
    setLoading(true);
    let obj = {
      Email: email,
      emailOTP: values.otp
    }
    try {
      const res = await _NewapplicationService.verifyOtpForUserAccount(obj);
      if (res.data.IsSuccess) {
        setLoading(false);
        message.success(OTP_VERIFIED_SUCCESSFULLY);
        localStorage.setItem(SESSION_TOKEN, res?.data?.Obj?.AuthToken);
        localStorage.setItem("userRole", res?.data?.Obj?.Role);
        history.push({
          pathname: routes.myApplications.path,
          state: { "email": email }
        });
      } else {
        setLoading(false);
        message.error(res.data.Message || COMMON_ERROR_MSG);
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }

  };

  const handleResendOtp = async () => {
    setLoading(true);
    let obj = {
      Email: email
    }
    try {
      const res = await _NewapplicationService.verifyEmail(obj);
      if (res.data.IsSuccess) {
        setLoading(false);
        setTimer(120); // Reset timer to 30 seconds
        message.success(OTP_SENT);
      } else {
        setLoading(false);
        message.error(res.data.Message || COMMON_ERROR_MSG);
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  }

  return (
    <Spin spinning={loading}>
      <LeftLayout>
        <div className="w450">
          <Row>
            <Col span={24}>
              <div>
                <Title level={3} style={{ marginBottom: 30 }}>
                  Verify Your Account
                </Title>
                <Text style={{ fontSize: 16 }}>
                  A six digit Verification Code was sent to <Text strong>{email}</Text>
                </Text>
                <Form
                  name="otp-verification"
                  layout="vertical"
                  onFinish={onFinish}
                  requiredMark={true}
                  style={{ marginTop: 28 }}
                >
                  <Form.Item
                    label="Enter Verification Code" 
                    name="otp"
                    rules={[
                      { required: true, message: "Please Enter OTP" },
                      {
                        pattern: /^\d{6}$/,
                        message: "OTP must be a 6-digit number",
                      },
                    ]}
                  >
                    <IntegerInput
                      maxLength={6}
                      placeholder="Enter 6-digit OTP"
                      autoComplete="one-time-code"
                    />
                  </Form.Item>
                  <Form.Item>
                    <div style={{ display: "flex", gap: 16 }}>
                      <Button
                        onClick={onBack}
                        icon={<LeftOutlined />}

                      >
                        Go Back
                      </Button>
                      <Button
                        type="primary"
                        htmlType="submit"
                      >
                        Confirm OTP <RightOutlined />
                      </Button>
                    </div>
                  </Form.Item>
                </Form>
                <Text type="secondary" style={{ display: "block", marginTop: 32, marginBottom: 15, fontSize: 15 }}>
                  Please wait 120 seconds before resending a new OTP:&nbsp;
                  <span style={{ fontWeight: 500 }}>
                    00:{timer.toString().padStart(2, "0")}
                  </span>
                </Text>
                <Button shape="round" disabled={timer > 0} onClick={handleResendOtp}>Resend</Button>
              </div>
            </Col>
          </Row>
        </div>
      </LeftLayout>
    </Spin>
  );
};

export default RegisteredEmailOtp;